<template>
  <div class="centering-step" :class="{'step-one': step == 1, 'step-two': step == 2}">
    <div class="step-item"><icon icon-class="cricle-check"></icon>{{stepOneText}}</div>
    <div class="step-item"><icon icon-class="cricle-check"></icon>{{stepTwoText}}</div>
  </div>
</template>

<style lang="less" scoped>
  .centering-step{
    width: 100%;
    height: 72px;
    background: #FFF;
    padding: 0 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .step-item{
      font-size: 16px;
      line-height: 16px;
      color: #999;
      svg{
        font-size: 16px;
        margin-right: 6px;
      }
    }
    &.step-one{
      .step-item:first-child{
        color: @xile;
        font-weight: bold;
      }
    }
    &.step-two{
      .step-item{
        color: @xile;
        font-weight: bold;
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: ['step', 'stepOneText', 'stepTwoText'],
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/enteringStep.vue